/**
 * @param {string|number} phoneCode 
 * @returns {string}
 */
export const normalizePhoneCode = (phoneCode) => {
  const phoneStr = phoneCode.toString().replace('+', '').trim();
  if (phoneStr.startsWith('1')) return '1';
  return phoneStr;
};